import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RCSwitch from 'rc-switch';
import './style/switch.less';
const Switch = ({ id, checked, onChange, className, disabled, labelA, labelB, }) => {
    let labelAClass;
    let labelBClass;
    const hiddenRender = '';
    const defaultStyleRender = '';
    if (checked === true) {
        labelAClass = 'labelA';
        labelBClass = 'labelB active';
    }
    else {
        labelAClass = 'labelA active';
        labelBClass = 'labelB';
    }
    return (_jsxs("span", Object.assign({ className: 'dixa-switch noselect ' + hiddenRender + defaultStyleRender + className }, { children: [_jsx("label", Object.assign({ className: labelAClass }, { children: labelA })), _jsx(RCSwitch, { disabled: disabled, id: id, onChange: typeof onChange === 'function'
                    ? onChange
                    : () => {
                        /** Noop. */
                    }, checked: checked }), _jsx("label", Object.assign({ className: labelBClass }, { children: labelB }))] })));
};
Switch.defaultProps = {
    id: '',
    checked: false,
    labelA: '',
    labelB: '',
    className: '',
    onChange: function () {
        /** Noop. */
    },
    disabled: false,
    hidden: false,
    invisibleOnDisabled: false,
};
export default Switch;
